import { TOAST } from "../config";

export interface Toast {
  show(text: string): void;
  update(delta: number): void;
  setNight(on: boolean): void;
  /** push the toast above whatever is pinned to the bottom of the screen */
  setLift(pixels: number): void;
}

export function createToast(): Toast {
  const element = document.getElementById("toast");
  let remaining = 0;

  let night = false;
  let lift = -1;

  return {
    setLift(pixels: number): void {
      if (!element || pixels === lift) return;
      lift = pixels;
      element.style.setProperty("--lift", `${Math.round(pixels)}px`);
    },
    setNight(on: boolean): void {
      if (!element || on === night) return;
      night = on;
      element.dataset.night = on ? "true" : "false";
    },
    show(text: string): void {
      if (!element) return;
      if (element.textContent !== text) element.textContent = text;
      element.dataset.state = "in";
      remaining = TOAST.hold;
    },
    update(delta: number): void {
      if (!element || remaining <= 0) return;
      remaining -= delta;
      if (remaining <= 0) element.dataset.state = "out";
    },
  };
}
